// extracted by mini-css-extract-plugin
export default {"root":"DashboardLoader_root__jvOsu","spinner":"DashboardLoader_spinner__SclYI"};